import { render, staticRenderFns } from "./CopiedTestsQuestion.vue?vue&type=template&id=0e1b3d84&scoped=true&"
import script from "./CopiedTestsQuestion.vue?vue&type=script&lang=ts&"
export * from "./CopiedTestsQuestion.vue?vue&type=script&lang=ts&"
import style0 from "./CopiedTestsQuestion.vue?vue&type=style&index=0&id=0e1b3d84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e1b3d84",
  null
  
)

export default component.exports